import script from "./MultiplePopover.vue?vue&type=script&setup=true&lang=ts"
export * from "./MultiplePopover.vue?vue&type=script&setup=true&lang=ts"

import "./MultiplePopover.vue?vue&type=style&index=0&id=b62c723c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b62c723c"]])

export default __exports__